export default "__VITE_PUBLIC_ASSET__3deee856__"